import { Link } from "@mui/material";
import { Box } from "@mui-wrapper";
import { runtimeConfig } from "@src/runtime-config";
import { Color } from "@utils/styles/default-colors";
import { isLocalhost } from "@faro-lotv/foundation";

const shouldShowCommitHash =
  runtimeConfig.commitId && runtimeConfig.commitId !== "0";

const shouldShowPRLink =
  runtimeConfig.pullRequestId &&
  runtimeConfig.pullRequestId !== "0" &&
  runtimeConfig.pullRequestUrl &&
  runtimeConfig.pullRequestUrl !== "0";

const shouldShowJiraLink =
  runtimeConfig.jiraTicketUrl &&
  runtimeConfig.jiraTicketUrl !== "0" &&
  runtimeConfig.jiraTicketId &&
  runtimeConfig.jiraTicketId !== "0";

const maxCommitHashLength = 8;
const commitSimplifiedHash = runtimeConfig.commitId.slice(
  0,
  maxCommitHashLength
);

/**
 * Shows additional information in the about dialog for local development, like the commit SHA and the pull request ID.
 */
export function AboutLocalInfo(): React.JSX.Element {
  const appVersion = isLocalhost()
    ? `Localhost ${runtimeConfig.appEnv}`
    : runtimeConfig.appVersion;

  return (
    <Box>
      <Box
        sx={{
          fontSize: "14px",
          color: Color.grey80,
          "& .MuiLink-root": {
            color: Color.blue,
            textDecoration: "none",

            "&:hover": {
              textDecoration: "underline",
            },
          },
        }}
      >
        {/* Version is always shown */}
        Version: <var>{appVersion}</var>
        <br />
        {/* Show the Git commit hash and the link to the commit in Azure DevOps */}
        {shouldShowCommitHash && (
          <>
            Commit SHA{" "}
            <Link href={runtimeConfig.commitUrl} target="_blank">
              <var>{commitSimplifiedHash}</var>
            </Link>
            <br />
          </>
        )}
        {/* Show the ticket Id and the link to the Jira ticket */}
        {shouldShowJiraLink && (
          <>
            Jira Ticket{" "}
            <Link href={runtimeConfig.jiraTicketUrl} target="_blank">
              <var>{runtimeConfig.jiraTicketId}</var>
            </Link>
            <br />
          </>
        )}
        {/* Show the pull request Id and the link to the PR in Azure DevOps */}
        {shouldShowPRLink && (
          <>
            Pull Request Id{" "}
            <Link href={runtimeConfig.pullRequestUrl} target="_blank">
              <var>{runtimeConfig.pullRequestId}</var>
            </Link>
          </>
        )}
      </Box>
    </Box>
  );
}
